// src/data/badges.js
// 学習バッジ・実績定義

export const BADGES = [
  // ─── 時間マイルストーン ───
  { id: 'first_log',    emoji: '🌱', name: '最初の一歩',     desc: '初めての学習ログを記録',         condition: (s) => s.totalLogs >= 1 },
  { id: 'hours_10',     emoji: '⚡', name: '10時間突破',     desc: '累計10時間学習達成',             condition: (s) => s.totalHours >= 10 },
  { id: 'hours_20',     emoji: '🚀', name: '離陸',           desc: '累計20時間学習達成',             condition: (s) => s.totalHours >= 20 },
  { id: 'hours_50',     emoji: '🔥', name: '50時間の炎',     desc: '累計50時間学習達成',             condition: (s) => s.totalHours >= 50 },
  { id: 'hours_100',    emoji: '💯', name: '100時間マスター', desc: '累計100時間学習達成',            condition: (s) => s.totalHours >= 100 },
  { id: 'hours_300',    emoji: '⚔️', name: '熟練者',         desc: '累計300時間学習達成',            condition: (s) => s.totalHours >= 300 },
  { id: 'hours_500',    emoji: '🏆', name: '500時間の壁突破', desc: '累計500時間学習達成',           condition: (s) => s.totalHours >= 500 },
  { id: 'hours_1000',   emoji: '👑', name: '1000時間達成',   desc: '伝説の1000時間を達成！',         condition: (s) => s.totalHours >= 1000 },
  // ─── ストリーク ───
  { id: 'streak_3',     emoji: '🌊', name: '3日連続',        desc: '3日間連続で学習',                condition: (s) => s.streak >= 3 },
  { id: 'streak_7',     emoji: '🗓️', name: '1週間連続',      desc: '7日間連続で学習',                condition: (s) => s.streak >= 7 },
  { id: 'streak_30',    emoji: '🌙', name: '1ヶ月連続',      desc: '30日間連続で学習',               condition: (s) => s.streak >= 30 },
  // ─── 品質 ───
  { id: 'quality_5',    emoji: '⭐', name: '最高の学習',      desc: '5つ星の学習を記録',              condition: (s) => s.maxQuality >= 5 },
  { id: 'quality_10',   emoji: '🌟', name: '10回の高品質',   desc: '5つ星の学習を10回達成',          condition: (s) => s.highQualityCount >= 10 },
  // ─── ログ数 ───
  { id: 'logs_10',      emoji: '📝', name: '記録魔',          desc: '10回ログを記録',                 condition: (s) => s.totalLogs >= 10 },
  { id: 'logs_50',      emoji: '📚', name: 'ログの達人',      desc: '50回ログを記録',                 condition: (s) => s.totalLogs >= 50 },
  // ─── カテゴリ制覇 ───
  { id: 'all_categories', emoji: '🎨', name: '万能学習者',    desc: '全7カテゴリで学習を記録',        condition: (s) => s.categoriesUsed >= 7 },
  // ─── 週次目標 ───
  { id: 'weekly_goal',  emoji: '🎯', name: '目標達成',        desc: '週次目標を達成',                 condition: (s) => s.weeklyGoalAchieved >= 1 },
  { id: 'weekly_goal_4',emoji: '🏅', name: '4週連続目標達成', desc: '4週連続で週次目標を達成',        condition: (s) => s.weeklyGoalAchieved >= 4 },
];

export const computeBadgeStats = (logs, streak, weeklyGoalHours) => {
  const totalHours = logs.reduce((sum, l) => sum + Number(l.hours || 0), 0);
  const totalLogs = logs.length;
  const maxQuality = Math.max(0, ...logs.map(l => l.quality_rating || 0));
  const highQualityCount = logs.filter(l => l.quality_rating >= 5).length;
  const categoriesUsed = new Set(logs.map(l => l.category)).size;

  // 週次目標達成回数（簡易計算: 週ごとに集計）
  const weekMap = {};
  logs.forEach(log => {
    const d = log.date?.toDate ? log.date.toDate() : new Date(log.date?.seconds * 1000 || 0);
    const week = Math.floor(d.getTime() / (7 * 24 * 60 * 60 * 1000));
    weekMap[week] = (weekMap[week] || 0) + Number(log.hours || 0);
  });
  const goal = weeklyGoalHours || 7;
  const weeklyGoalAchieved = Object.values(weekMap).filter(h => h >= goal).length;

  return { totalHours, totalLogs, streak, maxQuality, highQualityCount, categoriesUsed, weeklyGoalAchieved };
};
